module.exports = __webpack_public_path__ + "img/icons BFr_27.9098b29b.svg";